export default {
    'file.video': 'play_arrow',
    'file.google_pano': '360',
    'file.hosted_pano': '360'
}